import React from "react";
import { motion } from "framer-motion";
import { Home, FileText, Calendar, Settings } from "lucide-react";

const Sidebar = ({ isOpen,onSelectTab, onClose }) => {
  const sidebarVariants = {
    open: { x: 0 },
    closed: { x: "-100%" },
  };

  const handleSelect = (tab) => {
    onSelectTab(tab);
    onClose?.(); // close sidebar if needed
  };

  return (
    <motion.div
      initial="closed"
      animate={isOpen ? "open" : "closed"}
      variants={sidebarVariants}
      className="w-64 bg-gray-800 text-white p-4 fixed h-full z-10"
    >
      {/* <h2 className="text-2xl font-bold mb-6">Dashboard</h2> */}
      
      <nav className="mt-10">
        <ul className="space-y-2">
          {/* <li>
            <p
              onClick={() => handleSelect("home")}
              className="flex cursor-pointer items-center gap-2 p-2 hover:bg-gray-700 rounded"
            >
              <Home size={20} />
              Home
            </p>
          </li> */}
          <li>
            <p
              onClick={() => handleSelect("blogs")}
              className="flex cursor-pointer items-center gap-2 p-2 hover:bg-gray-700 rounded"
            >
              <FileText size={20} />
              Blogs
            </p>
          </li>
          <li>
            <p
              onClick={() => handleSelect("events")}
              className="flex cursor-pointer items-center gap-2 p-2 hover:bg-gray-700 rounded"
            >
              <Calendar size={20} />
              Events
            </p>
          </li>
          {/* <li>
            <a
              href="#"
              className="flex items-center gap-2 p-2 hover:bg-gray-700 rounded"
            >
              <Settings size={20} />
              Settings
            </a>
          </li> */}
        </ul>
      </nav>
    </motion.div>
  );
};

export default Sidebar;
